import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssignedDetailsPanelService {
  constructor(private ws: PostmethodService) { }

  getAssignedDetails(leadId: any) {
    return this.ws.wsGet(environment.baseUrl + "/lead/assign/lead-details/" + leadId);
  }
}
